import { render } from "./slide7.vue?vue&type=template&id=a53a8930&scoped=true"
import script from "./slide7.vue?vue&type=script&lang=js"
export * from "./slide7.vue?vue&type=script&lang=js"

import "./slide7.vue?vue&type=style&index=0&id=a53a8930&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53a8930"]])

export default __exports__